import React, { useState, useEffect } from 'react';
import './Blog.css';
import './Ribbon.css';
import { fetchMediumPosts, refreshMediumPosts } from '../../services/mediumService';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  const loadPosts = async (forceRefresh = false) => {
    try {
      setLoading(true);
      console.log('Blog: Starting to load posts, forceRefresh:', forceRefresh);
      const mediumPosts = await fetchMediumPosts(forceRefresh);
      console.log('Blog: Received posts:', mediumPosts?.length, mediumPosts);
      setPosts(mediumPosts || []);
    } catch (err) {
      setError('Failed to load blog posts: ' + err.message);
      console.error('Error loading posts:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPosts();
  }, []);

  const refreshPosts = async () => {
    try {
      setRefreshing(true);
      const data = await refreshMediumPosts();
      setPosts(data);
    } catch (err) {
      setError('Failed to refresh blog posts');
      console.error('Error refreshing posts:', err);
    } finally {
      setRefreshing(false);
    }
  };

  if (loading && !refreshing) {
    return (
      <section className="section-padding">
        <div className="container">
          <div className="text-center">
            <h1>Loading Bruce's Blog...</h1>
            <p>Fetching latest posts from Medium...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="section-padding">
        <div className="container">
          <div className="text-center text-danger">
            <h1>Unable to Load Blog</h1>
            <p>{error}</p>
            <button className="btn btn-primary" onClick={() => loadPosts(true)}>
              Try Again
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section-padding">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="section-title text-center">
              <h1 className="display-4 mb-3">
                Bruce's Blog {refreshing && <small>(Refreshing...)</small>}
              </h1>
            </div>
          </div>
        </div>
        <div className="row">
          {posts.map((post, index) => {
            // Process excerpt to replace media links
            let processedExcerpt = post.excerpt || '';
            const mediaLinkRegex = /https:\/\/medium\.com\/media\/[^\s]+/g;
            processedExcerpt = processedExcerpt.replace(mediaLinkRegex, 'Read More to Watch Video');

            return (
              <div key={post.guid} className="col-lg-4 col-md-6 mb-4">
                <div className="card h-100">
                  {index === 0 && (
                    <>
                      <div className="ribbon">
                        <div className="content">Latest</div>
                      </div>
                      <button 
                        className="refresh-button"
                        onClick={refreshPosts}
                        title="Refresh posts"
                        disabled={refreshing}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M23 4v6h-6"/>
                          <path d="M1 20v-6h6"/>
                          <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
                        </svg>
                      </button>
                    </>
                  )}
                  {post.image && (
                    <img
                      src={post.image}
                      className="card-img-top"
                      alt={post.title}
                    />
                  )}
                  <div className="card-body">
                    <h5 className="card-title">{post.title}</h5>
                    <p className="card-text">{processedExcerpt}</p>
                    {post.tags && post.tags.length > 0 && (
                      <div className="post-tags-container">
                        {post.tags.map((tag, tagIndex) => (
                          <span key={tagIndex} className="gold-pill-tag">
                            {tag}
                          </span>
                        ))}
                      </div>
                    )}
                    <div className="d-flex justify-content-between align-items-center">
                      <small className="text-muted">{post.date}</small>
                      <a
                        href={post.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-primary"
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {posts.length === 0 && !loading && (
          <div className="row">
            <div className="col-md-12 text-center">
              <p>No blog posts found. Try refreshing by clicking the title above.</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};



export default Blog; 